module.exports = __webpack_public_path__ + "img/sld_star_delta_transformer_t1_dark.63f7bfe7.svg";